import { useCallback } from 'react'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { useDeleteCurrentUserMotorCarrier } from 'apps/fleet-planner/types/apiTypes'
import { TOAST_ERROR_MESSAGE } from '../../../../../constants'

export interface IUseRemoveCarrierMutationPropsState {
  loading: boolean
  removeCarrier: () => Promise<boolean>
}

export interface IUseRemoveCarrierMutationProps {
  motorCarrierId: string
}

const useRemoveCarrierMutation = ({
  motorCarrierId,
}: IUseRemoveCarrierMutationProps): IUseRemoveCarrierMutationPropsState => {
  const { openToast } = useGlobalToast()

  const showErrorToast = useCallback(() => {
    openToast({ toastMessage: TOAST_ERROR_MESSAGE, toastType: 'alert' })
  }, [openToast])

  /**
   * Restful Mutations
   */
  const { loading, mutate: removeUserFromCarrier } = useDeleteCurrentUserMotorCarrier({})

  const removeCarrier = useCallback(async () => {
    try {
      await removeUserFromCarrier(Number(motorCarrierId))
      return true
    } catch {
      showErrorToast()
      return false
    }
  }, [motorCarrierId, removeUserFromCarrier, showErrorToast])

  return {
    loading,
    removeCarrier,
  }
}

export default useRemoveCarrierMutation
